import { useUser } from '../Contexts/UserContext';
import ClientDashboard from '../Screens/Client/Dashboard';
import TenantDashboard from '../Screens/Tenant/Dashboard';

export default function Dashboard() {
    const { type } = useUser();

    return (
        <>
            {type == 'client' && <ClientDashboard />}
            {type == 'tenant' && <TenantDashboard />}
        </>
    );
}